import React, { Component } from "react";

import "./style.css";

export default class Project extends Component {
  componentDidMount() {
    console.log("PR : ", this.props);
  }

  render() {
    return (
      <div className={` project portfolio-item`}>
        <div className="portfolio-link" data-toggle="modal" href="">
          <div className="portfolio-hover">
            <hr className="hTop" />
            <hr className="vRight" />

            <div className="portfolio-hover-content">
              <div className="portfolio-caption">
                <h4>{this.props.data.projectName}</h4>
                <p className="text-muted">{this.props.data.projectDesc}</p>
              </div>
            </div>
            <hr className="hDown" />
            <hr className="vLeft" />
          </div>
          <div className="imageContainer">
            <img
              className="img-fluid projectImg"
              src={this.props.data.projectImg}
              alt=""
            />
          </div>
        </div>
      </div>
    );
  }
}
